import moment from 'moment';

// This array holds the accepted date formats that the app uses, what the backend generates etc.
const acceptedDateInputFormats = ['YYYY-MM-DDTHH:mm:ss.SSSSZ'];
const dateOutputFormat = 'MMM D, YYYY';

// format date to MMM D, YYYY
export const date = value => {
  // if (process.env.NODE_ENV === 'test') {
  //   moment.tz.setDefault('EST');
  // }

  // Check if input date is truthy and a valid ISO 8601 date
  if (value && moment(value, moment.ISO_8601).isValid()) {
    // Check if input date is an accepted format of the application (acceptedDateFormats)
    // Use "Strict mode" to validate input format: http://momentjs.com/guides/#/parsing/strict-mode/
    let acceptedFormat = moment(value, acceptedDateInputFormats, true).format(
      dateOutputFormat
    );

    // If the accepted format check fails moment returns 'Invalid date', but we want to return an emptry string
    if (acceptedFormat === 'Invalid date') acceptedFormat = '';

    // If the check passes return the formatted date in 'dateOutputFormat' format
    return acceptedFormat;
  } else {
    // Fails if value is falsey or value is not ISO 8601
    return '';
  }
};

// format number to comma'd number using Intl.NumberFormat:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat/format
const formattingOptions = {};
// Note: No support from lower than Andriod 4.4
const numberFormat = new Intl.NumberFormat('en-US', formattingOptions);
export const toCommaNumber = value => {
  // zero should be still formatted if not null or undefined
  if ((!value && value !== 0) || isNaN(value)) {
    return;
  }

  // let NumberFormat format, add back the zeros and dots
  // validation should happen after the format
  let addition = '';
  if (value) {
    const str = value.toString();

    // in case in the middle of typing (NumberFormat strips off the last dot)
    if (str.slice(-1) === '.') {
      addition = '.';
      // in case the number is xxx.00 case (NumberFormat strips off decimal including dot)
    } else if (str.split('.') && Number(str.split('.')[1]) === 0) {
      addition = `.${str.split('.')[1]}`;
      // in case the number is xxx.50 case (NumberFormat strips off the last zero)
    } else if (str.slice(-1) === '0' && str.indexOf('.') >= 0) {
      addition = '0';
    }
  }
  return `${numberFormat.format(value)}${addition}`;
};

export const shortenFormat = (value, limit) =>
  value && value.length > limit
    ? `${value.slice(0, limit - Math.round(limit / 2))}...${value.slice(
        Math.round(limit / -2)
      )}`
    : value;

/**
 *
 *
 * @function removeWhiteSpaceAndNewLineAndLowercase
 * @param {string} string - string to manupulate
 * @public
 */
export const removeWhiteSpaceAndNewLineAndLowercase = string => {
  return (string || '').replace(/[\s\n\r]+/g, '').toLowerCase();
};



// WEBPACK FOOTER //
// ./src/common/formatters.js